import { useQueries, useQueryClient } from "react-query";
import { getDeviceThermocouplesService } from "shared/services";
import { applyThermocoupleSetting } from "shared/helpers/thermocoupleCache";
import { thermocoupleSettingKey } from "shared/hooks/useReceivedThermocoupleSetting";

export const useGetThermocouplesQueries = (switchStatus, swtName) => {
    const queryClient = useQueryClient();
    const getSSRsQueries = useQueries(
        Object.values(switchStatus)
            .flatMap((zone) =>
                Object.values(zone)
                    .filter(machine => machine.thermocoupleFault?.includes(1))
                    .map((machine) => ({
                        queryKey: [machine.deviceMac, '-thermocouple'],
                        queryFn: () => getDeviceThermocouplesService(machine.deviceMac),
                        onSuccess: (data) => {
                            if (data) {
                                data.forEach(thermocouple => {



                                    queryClient.setQueryData(
                                        thermocoupleSettingKey(thermocouple.device_id),
                                        (old) =>
                                            applyThermocoupleSetting(old, {
                                                ...thermocouple,
                                                deviceType: swtName,
                                            })
                                    );
                                });
                            }
                        },
                        onError: (error) => {
                            console.error('get thermocouples fail:', error.message);
                        },
                        staleTime: Infinity
                    }))
            )
    );

    return getSSRsQueries;
};
